import { apiFetch } from '../../../lib/http';

/**
 * Account-level operations. Backed by the real backend `AccountController`
 * (`ai-learn-api`): a soft delete that cancels active subscriptions,
 * anonymizes the user's data, and removes the Firebase auth user.
 */
export async function deleteAccount() {
  return apiFetch('/api/v1/account', { method: 'DELETE' });
}
